import { MultiService } from 'modules/api/MultiService';

export const makeWorkerGatewayAuthorization = (jwtToken?: string) => {
  const service = MultiService.getService();

  if (jwtToken) {
    service.getWorkerGateway().addJwtToken(jwtToken);
  }
};
